import { render, staticRenderFns } from "./AdditionalPurchase.vue?vue&type=template&id=48699cdf&scoped=true&"
import script from "./AdditionalPurchase.vue?vue&type=script&lang=js&"
export * from "./AdditionalPurchase.vue?vue&type=script&lang=js&"
import style0 from "./AdditionalPurchase.vue?vue&type=style&index=0&id=48699cdf&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48699cdf",
  null
  
)

export default component.exports